export const VENUE_ONBOARDING_STEPS = [
  "WELCOME",
  "BUSINESS",
  "CATEGORY",
  "LOGO",
  "REVIEW",
] as const;

export type VenueOnboardingStep = (typeof VENUE_ONBOARDING_STEPS)[number];

export const VENUE_STEP_LABELS: Record<VenueOnboardingStep, string> = {
  WELCOME: "Welcome",
  BUSINESS: "Business",
  CATEGORY: "Category",
  LOGO: "Logo",
  REVIEW: "Review",
};
